'use client'

import { CartItem } from '@/components/Cart'
import { useCart } from '@payloadcms/plugin-ecommerce/client/react'
import { MinusIcon, PlusIcon } from 'lucide-react'
import React, { useMemo } from 'react'

import { cn } from '@/utilities/cn'

/**
 * Плюс и минус у количества. Плюс гаснет, когда на складе больше нет —
 * рядом строка сама подписывает, почему кнопка недоступна.
 */
export function EditItemQuantityButton({ type, item }: { item: CartItem; type: 'minus' | 'plus' }) {
  const { decrementItem, incrementItem, isLoading } = useCart()

  const disabled = useMemo(() => {
    if (!item.id) return true

    const target =
      item.variant && typeof item.variant === 'object'
        ? item.variant
        : item.product && typeof item.product === 'object'
          ? item.product
          : null

    if (type === 'plus' && typeof target?.inventory === 'number' && typeof item.quantity === 'number') {
      return item.quantity >= target.inventory
    }

    return false
  }, [item, type])

  const isDisabled = disabled || isLoading

  return (
    <button
      aria-label={type === 'plus' ? 'Больше' : 'Меньше'}
      className={cn(
        'flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-ink transition-colors',
        isDisabled ? 'cursor-not-allowed text-ink/25' : 'hover:cursor-pointer hover:bg-ink hover:text-sun',
      )}
      disabled={isDisabled}
      onClick={() => {
        if (!item.id) return
        if (type === 'plus') incrementItem(item.id)
        else decrementItem(item.id)
      }}
      type="button"
    >
      {type === 'plus' ? <PlusIcon className="h-4 w-4" /> : <MinusIcon className="h-4 w-4" />}
    </button>
  )
}
